import { createTheme } from '@mui/material/styles'

const primaryColor = '#004190'

/** カスタマイズしたテーマオブジェクトの取得 */
export const theme = createTheme({
  components: {
    // ボタン
    MuiButton: {
      styleOverrides: {
        root: {
          // ボタンの文字（共通）
          fontSize: '18px',
        },
        // 主ボタンの色
        containedPrimary: {
          backgroundColor: primaryColor
        },
        // 副ボタンの色
        outlinedPrimary: {
          color: primaryColor,
          borderColor: primaryColor + '44',
          backgroundColor: '#fff8'
        }
      }
    },
    // テキストボックス
    MuiInputBase: {
      styleOverrides: {
        root: {
          // テキストボックスの背景色
          backgroundColor: '#fff'
        },
      },
    },
  },
})

export default theme
